import { createSelector } from '@reduxjs/toolkit';

import type { AssetsAssetSchemaTypedWithId } from '@iconik-io/iconik-api/src/services/assets';
import { OBJECT_TYPE_ASSETS } from '@iconik-io/iconik-api/src/types/object_types';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import selectMergedPermissions from '../../components/permissions_manager/selectors';
import type { AppState } from '../../store/types';
import { selectUserRoles } from '../../utils/get_user_roles';
import { selectIsLatestVersion } from '../version/selectors';

const getAsset = (
  _state: AppState,
  asset: AssetsAssetSchemaTypedWithId | SearchItemEntity | undefined,
) => asset;

const getPermissionsRolesMerge = (
  state: AppState,
  asset: AssetsAssetSchemaTypedWithId | SearchItemEntity | undefined,
) => selectMergedPermissions(state, OBJECT_TYPE_ASSETS, asset?.id);

export const selectCanUploadToPlaceholder = createSelector(
  [selectUserRoles, getPermissionsRolesMerge, getAsset],
  (userRoles, permissionsRolesMerge, asset) =>
    userRoles.canCreateFormats &&
    userRoles.canWriteFormats &&
    userRoles.canWriteFiles &&
    userRoles.canReadStorages &&
    userRoles.webCanUpload &&
    permissionsRolesMerge?.write &&
    asset?.type === 'PLACEHOLDER',
);

export const selectCanCreateSubclips = createSelector(
  [selectUserRoles, selectIsLatestVersion],
  (userRoles, isLatestVersion) =>
    isLatestVersion &&
    userRoles.canCreateAssets &&
    userRoles.canCreateSubclips &&
    userRoles.canCreateSegments,
);
